import React from "react";

export const BackIcon = React.memo(({color = "var(--messenger-blue)"}: any) => {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M18.7915 11.005H7.62148L12.5015 6.12501C12.8915 5.73501 12.8915 5.09501 12.5015 4.70501C12.1115 4.31501 11.4815 4.31501 11.0915 4.70501L4.50148 11.295C4.11148 11.685 4.11148 12.315 4.50148 12.705L11.0915 19.295C11.4815 19.685 12.1115 19.685 12.5015 19.295C12.8915 18.905 12.8915 18.275 12.5015 17.885L7.62148 13.005H18.7915C19.3415 13.005 19.7915 12.555 19.7915 12.005C19.7915 11.455 19.3415 11.005 18.7915 11.005Z" fill={color}/>
        </svg>
    )
});